import { BrowserRouter, Navigate, Route, Routes } from "react-router-dom"
import { ActiveUserLayout } from "components/Layouts/ActiveUserLayout"
import { AdminUserLayout } from "components/Layouts/AdminUserLayout"
import { AuthorizedUserLayout } from "components/Layouts/AuthorizedUserLayout"
import { LoginPagesLayout } from "components/Layouts/LoginPagesLayout"
import { CategoryAccessLayout } from "components/Layouts/CategoryAccessLayout"
import { ProductCategories, ProductCategoriesLink } from "components/Navbar/types"
import { MerchantPage } from "pages/Merchants/MerchantPage"
import { MerchantsPage } from "pages/Merchants/MerchantsPage"
import { UsersPage } from "pages/Users/UsersPage"
import { UserPage } from "pages/Users/UserPage"
import { UserSettingsPage } from "pages/Users/UserSettingsPage"
import { BrandsPage } from "pages/Brands/BrandsPage"
import { BrandPage } from "pages/Brands/BrandPage"
import { LooksPage } from "pages/Looks/LooksPage"
import { LookPage } from "pages/Looks/LookPage"
import { TranslatesPage } from "pages/TranslatesPage"
import { UICustomization } from "pages/UICustomization"
import { IntegrationInfo } from "pages/IntegrationInfo"
import { ConfigurationPage } from "pages/ConfigurationPage"
import { ReEnterIntegration } from "pages/ReEnterIntegration"
import { LoginPage } from "pages/LoginPage"
import { LoginTiendanubePage } from "pages/LoginTiendanubePage"
import { ActivateAccount } from "pages/ActivateAccount"
import { ProductsPage } from "pages/Products/ProductsPage"
import { ProductPage } from "pages/Products/ProductPage"
import { GlassesEditorPage } from "pages/Products/Glasses/GlassesEditorPage"
import { AlertProvider } from "providers/AlertProvider"
import { PageNotFound } from "pages/NotFoundPage.tsx"
import { AnalyticsPage } from "pages/Analytics/AnalyticsPage"
import { typedEnv } from "./config/typedEnv"

const App = () => {
  return (
    <BrowserRouter
      future={{
        v7_relativeSplatPath: true,
        v7_startTransition: true,
      }}
    >
      <AlertProvider>
        <Routes>
          {typedEnv.MODE === "test" && (
            <Route
              path="/__e2e/clerk"
              element={<div data-testid="e2e-clerk-ready" className="sr-only" />}
            />
          )}
          <Route path="/login/tiendanube" element={<LoginTiendanubePage />} />
          <Route element={<AuthorizedUserLayout />}>
            <Route element={<ActiveUserLayout />}>
              <Route element={<AdminUserLayout />}>
                <Route path="/users" element={<UsersPage />} />
                <Route path="/users/edit" element={<UserPage />} />
                <Route path="/users/add" element={<UserPage add />} />
                <Route path="/merchants/add" element={<MerchantPage add />} />
                <Route path="/merchants/edit" element={<MerchantPage />} />
                <Route path="/merchants" element={<MerchantsPage />} />
                <Route path="/brands" element={<BrandsPage />} />
                <Route path="/brands/edit" element={<BrandPage />} />
                <Route path="/brands/add" element={<BrandPage add />} />
                <Route path="/translates" element={<TranslatesPage />} />
                <Route path="/ui-customization/edit" element={<UICustomization />} />
              </Route>
              <Route path="/looks" element={<LooksPage />} />
              <Route path="/looks/edit" element={<LookPage />} />
              <Route path="/looks/add" element={<LookPage add />} />
              <Route path="/ui-customization" element={<UICustomization />} />
              <Route path="/integration-info" element={<IntegrationInfo />} />
              <Route path="/configuration" element={<ConfigurationPage />} />
              <Route path="/analytics" element={<AnalyticsPage />} />
              <Route element={<CategoryAccessLayout />}>
                <Route path="*" element={<PageNotFound />} />
                <Route path="/" element={<Navigate to={ProductCategoriesLink.MAKEUP} />} />
                <Route
                  path={ProductCategoriesLink.MAKEUP}
                  element={<ProductsPage category={ProductCategories.MAKEUP} />}
                />
                <Route path={`${ProductCategoriesLink.MAKEUP}/edit`} element={<ProductPage />} />
                <Route path={`${ProductCategoriesLink.MAKEUP}/add`} element={<ProductPage add />} />
                <Route
                  path={ProductCategoriesLink.GLASSES}
                  element={<ProductsPage category={ProductCategories.GLASSES} />}
                />
                <Route
                  path={`${ProductCategoriesLink.GLASSES}/add`}
                  element={<GlassesEditorPage />}
                />
                <Route
                  path={`${ProductCategoriesLink.GLASSES}/edit`}
                  element={<GlassesEditorPage />}
                />
              </Route>
              <Route path="/activate-account" element={<ActivateAccount />} />
            </Route>
            <Route path="/user-settings/*" element={<UserSettingsPage />} />
            <Route path="/login/integrations/re-enter" element={<ReEnterIntegration />} />
          </Route>
          <Route element={<LoginPagesLayout />}>
            <Route path="/login" element={<LoginPage />} />
          </Route>
        </Routes>
      </AlertProvider>
    </BrowserRouter>
  )
}

export default App
